import { render, staticRenderFns } from "./CarBrandSeriesModel.vue?vue&type=template&id=b4ac42fc"
import script from "./CarBrandSeriesModel.vue?vue&type=script&lang=js"
export * from "./CarBrandSeriesModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports